"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _cell = _interopRequireDefault(require("../cell"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _bind["default"].bind(_style["default"]);

var Rows = function Rows(_ref) {
  var rows = _ref.rows,
      columns = _ref.columns,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      renderRow = _ref.renderRow;
  return /*#__PURE__*/_jsx("tbody", {}, void 0, rows.map(function (row, rowIdx) {
    var rowClasses = cx({
      'xsui-table-rows__row': true,
      'xsui-table-rows__row--colored': !(rowIdx % 2)
    });

    if (renderRow) {
      return renderRow({
        row: row,
        columns: columns,
        compact: compact,
        rowIndex: rowIdx,
        className: rowClasses,
        CellComponent: _cell["default"]
      });
    }

    return /*#__PURE__*/_jsx("tr", {
      className: rowClasses
    }, "row-".concat(row.id || rowIdx), columns.map(function (column, columnIdx) {
      return /*#__PURE__*/_jsx(_cell["default"], {
        row: row,
        column: column,
        rowIndex: rowIdx,
        columnIndex: columnIdx,
        compact: compact
      }, "row-".concat(row.id || rowIdx, "-").concat(column.id));
    }));
  }));
};

var _default = Rows;
exports["default"] = _default;